import { render, staticRenderFns } from "./Vordach.vue?vue&type=template&id=19a30c28&"
import script from "./Vordach.vue?vue&type=script&lang=js&"
export * from "./Vordach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports